import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IAccountRepresentativesContextValue } from './types';

export default createContext<IAccountRepresentativesContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
